// main.js
import { createApp } from 'vue';
import App from './App.vue';
import mitt from 'mitt';
import store from '../store/index';
import request from '../common/request/index.js';
import api from './service/index.js';
import language from './language/index.js';
import components from './init/components.js';
import router from './init/routers.js';

// ★ 修复 #21：去掉 vue-quill-editor / quill 的 import 和 css
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import draggable from './directives/draggable';
import { hasPermission } from '@/utils/permission';

import userModule from '../store/modules/user';

async function initApp() {
  await userModule.init();

  const app = createApp(App);

  // ★ 修复 #39：注册顺序调整：先插件后组件，无 quill
  app.use(api);
  app.use(ElementPlus, { locale: zhCn });
  app.use(components);
  app.use(language);
  app.use(request);
  app.use(router.init());

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }

  app.config.globalProperties.$bus = new mitt();
  app.config.globalProperties.$store = store;
  app.config.globalProperties.$hasPermission = hasPermission;

  app.directive('draggable', draggable);

  const icons = Object.entries(ElementPlusIconsVue).map(([key, component]) => ({ key, icon: component }));
  store.commit('icons/setList', icons);

  app.mount('#app');
}

initApp().catch((err) => {
  console.error('应用启动失败:', err);
});